import get from 'lodash/get';
import axios from 'axios';
import { SimpleOpeningHours } from 'simple-opening-hours';
import { API_URL_OVERPASS } from '~/config/settings/settingsApi';
import OSM_IDS from '~/config/ids/idsOsm';

export default {

    /**
     *
     */
    async loadRestaurant(restaurantId) {

        const osmId = OSM_IDS[restaurantId];

        if (!osmId) return null;

        try {
            const result = await axios.get(API_URL_OVERPASS, {
                params: {
                    data: `[out:json][timeout:5];(node(${osmId});way(${osmId}););out;>;out skel qt;`,
                },
            });

            const element = get(result, 'data.elements[0]', null);

            return element ? {
                name: get(element.tags, 'name', ''),
                image: null,
                type: this.parseType(element),
                phoneNumber: get(element.tags, 'phone', ''),
                website: get(element.tags, 'website', ''),
                address: this.parseAddress(element),
                parsedOpeningHours: this.parseOpeninghours(element),
            } : null;

        } catch (error) {
            console.error('Error fetching open street map restaurant API data', error);
        }
        return null;
    },

    /**
     *
     */
    parseAddress(element) {
        return [
            `${get(element.tags, 'addr:street', '')} ${get(element.tags, 'addr:housenumber', '')}`.trim(),
            `${get(element.tags, 'addr:postcode', '')} ${get(element.tags, 'addr:city', '')}`.trim(),
        ].join('\n');
    },

    /**
     *
     */
    parseOpeninghours(element) {
        if (element.tags.opening_hours) {
            return new SimpleOpeningHours(element.tags.opening_hours);
        }
        return null;
    },

    /**
     *
     */
    parseType(element) {
        return get(element.tags, 'amenity', '') === 'bar' ? 'BAR' : 'RESTAURANT';
    },
};
